export enum MortgageApplicationContext {
  Unknown,
  Internal,
  Broker,
  Branch,
  Direct
}
